import script from "./AzimuthFacadeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AzimuthFacadeView.vue?vue&type=script&setup=true&lang=ts"

import "./AzimuthFacadeView.vue?vue&type=style&index=0&id=2f0a88fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f0a88fa"]])

export default __exports__